<div>
    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalProcedimientos }}</div>
            <div class="listado__stat-label">Total</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ procedimientosMostrados }}</div>
            <div class="listado__stat-label">Mostrando</div>
        </div>
    </div>
    <div class="listado listado--cards-accent">
    <table mat-table [dataSource]="dataSource" matSort class="table align-middle mb-0 bg-white">
        <!-- Position Column -->
        <ng-container matColumnDef="departamento.nombre" class="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by departamento.nombre" class="header">{{ 'PROCEDIMIENTO.LIST.COLUMN.DEPARTMENT' | translate }}</th>
            <td mat-cell *matCellDef="let element" style="padding-top: 1%; width: 20%;" attr.data-label="Departamento"> {{element.departamento.nombre}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="nombre">
            <th class="asuntoNombre" mat-header-cell *matHeaderCellDef mat-sort-header
                sortActionDescription="Sort by nombre" class="header">{{ 'TRAMITE.FORM.LABEL.NOMBRE' | translate }}</th>
            <td mat-cell *matCellDef="let element" style="padding-top: 1%;" attr.data-label="Nombre" data-role="title"> {{element.nombre}} </td>
        </ng-container>

        <ng-container matColumnDef="visible">
            <th mat-header-cell *matHeaderCellDef class="header">{{ 'PROCEDIMIENTO.LIST.COLUMN.STATUS' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="mat-column" style="padding-top: 1%;" attr.data-label="Estado" data-role="status">
                <button class="asuntoActivo" *ngIf="element.visible">{{ 'TRAMITE.CONTENT.NBSP_ACTIVO_NBSP' | translate }}</button>
                <button class="asuntoInactivo" *ngIf="!element.visible">{{ 'COMMON.STATUS.INACTIVE' | translate }}</button>
            </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="header"></th>
            <td mat-cell *matCellDef="let element" class="mat-column em-td-actions" data-role="actions" attr.data-label="Acciones" style="padding-top: 1%; width: 15%;">
                <div class="em-actions-wrap">
                    <button type="button" class="em-icon-btn" matTooltip="Ver" (click)="openDialog(element)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button type="button" class="em-icon-btn em-icon-btn--danger" matTooltip="Eliminar" (click)="openDeleteDialog(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No se encontro el nombre "{{input.value}}"</td>
        </tr> -->
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
    </mat-paginator>
    </div>
</div>